import { typographyV2 } from '@toggle/design-system';
import styled from 'styled-components';

export const SectionRow = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const TitleMedium = styled.div`
  ${typographyV2.titleMd};
`;

export const BodySmall = styled.div`
  ${typographyV2.bodySm};
`;

export const StepperWrapper = styled.div`
  width: 100%;
  height: 76px;
  border: 1px solid var(--border-soft);
  border-radius: 8px;
  padding: 18px;
`;

export const HeaderWrapper = styled.div`
  display: flex;
  width: 100%;
  justify-content: space-between;
  align-items: center;
`;
